import { GET_MY_ORGANIZATION } from "./../graphql/queries/getMyOrganization"
import { useMutation } from "@apollo/client"
import { REMOVE_ORGANIZATION_JOIN_REQUEST } from "../graphql/mutations/removeOrganizationJoinRequest"
import { GET_ORGANIZATION_PENDING_INVITES } from "../graphql/queries/getOrganizationPendingInvites"
import { GET_USER_ORG_JOIN_REQUEST } from "../graphql/queries/getUserOrgJoinRequests"
import { GET_MY_ORGANIZATION_SUBORGS } from "../graphql/queries/getMyOrganizationSuborgs"
import { GET_MY_ORGANIZATION_PENDING_INVITATIONS } from "../graphql/queries/getMyOrganizationPendingInvitations"

export const useRemoveOrgJoinRequest = ({ onCompleted, onError }) => {
  const [removeOrgJoinRequest, { client, data, loading }] = useMutation(REMOVE_ORGANIZATION_JOIN_REQUEST, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [
      GET_ORGANIZATION_PENDING_INVITES,
      GET_USER_ORG_JOIN_REQUEST,
      GET_MY_ORGANIZATION,
      GET_MY_ORGANIZATION_SUBORGS,
      GET_MY_ORGANIZATION_PENDING_INVITATIONS,
    ],
  })

  return { removeOrgJoinRequest, data, loading, client }
}
